import { render, staticRenderFns } from "./POAList.vue?vue&type=template&id=05f90a58"
import script from "./POAList.vue?vue&type=script&lang=js"
export * from "./POAList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports